import React from 'react';
import { IconProps } from '../types';

export const DevOpsIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_9520_40290)">
            <path
                d="M3.5 31C4.88071 31 6 29.8807 6 28.5C6 27.1193 4.88071 26 3.5 26C2.11929 26 1 27.1193 1 28.5C1 29.8807 2.11929 31 3.5 31Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M16 31C17.3807 31 18.5 29.8807 18.5 28.5C18.5 27.1193 17.3807 26 16 26C14.6193 26 13.5 27.1193 13.5 28.5C13.5 29.8807 14.6193 31 16 31Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M28.5 31C29.8807 31 31 29.8807 31 28.5C31 27.1193 29.8807 26 28.5 26C27.1193 26 26 27.1193 26 28.5C26 29.8807 27.1193 31 28.5 31Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path d="M16 26V19" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
            <path d="M26.733 26.733L24 24V19" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
            <path d="M5.26807 26.732L8.00007 24V19" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
            <path
                d="M25 7.00001C24.827 7.00001 24.656 7.01201 24.486 7.02601C23.8715 5.2653 22.7245 3.73933 21.204 2.65958C19.6836 1.57983 17.8649 0.999756 16 0.999756C14.1351 0.999756 12.3164 1.57983 10.796 2.65958C9.27549 3.73933 8.12852 5.2653 7.514 7.02601C7.344 7.01201 7.173 7.00001 7 7.00001C5.4087 7.00001 3.88258 7.63215 2.75736 8.75737C1.63214 9.88259 1 11.4087 1 13C1 14.5913 1.63214 16.1174 2.75736 17.2426C3.88258 18.3679 5.4087 19 7 19H25C26.5913 19 28.1174 18.3679 29.2426 17.2426C30.3679 16.1174 31 14.5913 31 13C31 11.4087 30.3679 9.88259 29.2426 8.75737C28.1174 7.63215 26.5913 7.00001 25 7.00001Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
        </g>
        <defs>
            <clipPath id="clip0_9520_40290">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
